<template>
  <div class="sidebar">
    <h3>Items</h3>
    <div class="checkboxes">
      <div class="checkboxlabel" :class="{ on: sectionsFlightsIsOn }" @click="toggle('sectionsFlightsIsOn')">
        <div class="checkbox" />
        <label>Flights</label>
      </div>
      <div class="checkboxlabel" :class="{ on: sectionsHotelsIsOn }" @click="toggle('sectionsHotelsIsOn')">
        <div class="checkbox" />
        <label>Hotels</label>
      </div>
      <div class="checkboxlabel" :class="{ on: sectionsCarsIsOn }" @click="toggle('sectionsCarsIsOn')">
        <div class="checkbox" />
        <label>Cars</label>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  sectionsFlightsIsOn: Boolean,
  sectionsHotelsIsOn: Boolean,
  sectionsCarsIsOn: Boolean,
});

const emit = defineEmits(["update:sectionsFlightsIsOn", "update:sectionsHotelsIsOn", "update:sectionsCarsIsOn"]);

const toggle = section => {
  emit(`update:${section}`, !props[section]);
};
</script>

<style lang="less">
#new {
  .sidebar {
    .checkboxlabel {
      margin-top: 1rem;
    }
  }
}
</style>
